import { Component, OnInit } from '@angular/core';
import { FormBuilder, NgForm, Validators} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { UtilityService } from 'src/app/services/utility.service';
import { ThemeService } from 'src/app/services/theme.service';
import { SessionService } from 'src/app/services/session.service';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';
import { environment } from 'src/environments/environment';
import { messages } from '../../../../../common/messages'
import { regex ,EmailNoWhitespaceValidator} from '../../../../../common/regex';
import icVisibility from '@iconify/icons-ic/twotone-visibility';
import icVisibilityOff from '@iconify/icons-ic/twotone-visibility-off';

@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss'],
    standalone: false
})
export class SpecialistSignInComponent implements OnInit {


  //variables
  assets = environment.assets;
  public form: any;
  message: any
  emailRegex = regex.pattern.EMAIL
  passwordRegex = regex.pattern.PASSWORD
  hide = true;
  hide1 = true;
  hide2 = true;
  icVisibility = icVisibility;
  icVisibilityOff = icVisibilityOff;
  isSpecialtyIntakeEnabled: boolean = false;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private api: ApiService,
    private utility: UtilityService,
    public themeService: ThemeService,
    public sessionService: SessionService,
    private featureFlagService: FeatureFlagService
  ) {

  }

  ngOnInit(): void {

    this.message = messages
    this.isSpecialtyIntakeEnabled = this.featureFlagService.isSpecialtyIntakeEnabled();
    this.setupSigninForm();

  }

  setupSigninForm() {
    this.form = this.fb.group({
      email: [null,
        Validators.compose([
          Validators.required,
          EmailNoWhitespaceValidator
          ])],

      password: [null,
        Validators.compose([
          Validators.required,
          this.noWhitespaceValidator,
          Validators.pattern(this.passwordRegex)])],

      rememberMe: [false] // MPH session timeout: Remember Me checkbox
    });
  }

  noWhitespaceValidator(control: any) {
    const isWhitespace = (control.value || '').match(/\s/g)
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  signIn(userData: any) {
    this.utility.setSpinner(true)
    userData['userType'] = 'specialist'

    this.api.apiRequest("post", "user/signin", userData)
      .subscribe(result => {
        this.utility.setSpinner(false)

        if (result.status == "success") {
          this.utility.openSnackBar("Signin successful.", "Ok")
          let userData = result.data;
          // Check for returnUrl parameter
          const returnUrl = this.route.snapshot.queryParams['returnUrl'];
          
          if (userData.userType == 'specialist') {
            if (returnUrl) {
              this.router.navigateByUrl(returnUrl);
            } else if (userData.status == 'active') {
              this.router.navigate(['specialist/dashboard/day2']);
            } else {
              this.router.navigate(['specialist/dashboard']);
            }
          }

          // // Store the values in local storage
          localStorage.setItem("endUserEmail", userData.email)
          localStorage.setItem("endUserId", userData._id)
          localStorage.setItem("endUserType", userData.userType)
          localStorage.setItem("endUserFullName", userData.firstName + ' ' + userData.lastName)
          localStorage.setItem("endUserFirstName", userData.firstName)
          localStorage.setItem("endUserLastName", userData.lastName)
          localStorage.setItem("accessToken", userData.accessToken)
          localStorage.setItem("contactNumber", userData.contactNumber)
          localStorage.setItem("status", userData.status)
          if (userData.notificationPreferences) {
            if (userData.notificationPreferences.defaultCategory) {
              localStorage.setItem("notificationCenter_defaultCategory", userData.notificationPreferences.defaultCategory)
            }
            if (userData.notificationPreferences.showUnreadOnly !== undefined) {
              localStorage.setItem("notificationCenter_defaultUnreadOnly", String(userData.notificationPreferences.showUnreadOnly))
            }
            if (userData.notificationPreferences.defaultCaseScope) {
              localStorage.setItem("notificationCenter_defaultCaseScope", userData.notificationPreferences.defaultCaseScope)
            }
          }
          if (userData.profilePic) {
            localStorage.setItem("profilePic", environment.documentBaseUrl + "profilePic/" + userData.profilePic)

          }

          // MPH session timeout: Start session monitoring
          // const rememberMe = this.form.value.rememberMe || false;
          // this.sessionService.startSession(rememberMe);
          // Removed as per the comment on from Samantha on SD-364

        } else {

          if (result.data.invalidEmail) {
            this.form.controls['email'].setErrors({ 'invalidEmail': true })
          } else if (result.data.invalidPassword) {

            this.form.controls['password'].setValue('');
            this.form.controls['password'].markAsUntouched();
            this.form.controls['password'].setErrors({ 'invalidPassword': true });
          } else if (result.data.accountNotVerified) {
            this.form.controls['email'].markAsUntouched();
            this.form.controls['email'].setErrors({ 'accountNotVerified': true })
          }
          else if (result.data.userNotActive) {
            this.form.controls['email'].markAsUntouched();
            this.form.controls['email'].setErrors({ 'userNotActive': true })
          } else if (result.data.otherAccount) {
            this.form.controls['email'].markAsUntouched();
            this.form.controls['email'].setErrors({ 'invalidLoginType': true })
          }
          else {
            this.form.controls['email'].markAsUntouched();
            this.form.controls['email'].setErrors({ 'differentAccount': false })
          }
        }

      }, (err) => {
        this.utility.setSpinner(false)
        // this.router.navigate(["/error/404"])
      })
  }

  /**
   * Initiate SAML SSO login
   */
  loginWithEntra(): void {
    if (!this.isSpecialtyIntakeEnabled) {
      return;
    }

    // SAML SP-initiated: direct browser redirect to backend login endpoint
    const serverUrl = this.api.serverUrl;
    window.location.href = `${serverUrl}/api/auth/saml/login`;
  }
}
